import { render, staticRenderFns } from "./safe_zone_contacts.vue?vue&type=template&id=ffc695ee"
import script from "./safe_zone_contacts.vue?vue&type=script&lang=js"
export * from "./safe_zone_contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports